import BasePropertyView from 'BasePropertyView.js'
import htmlTemplate from 'properties/accessibility/accessibility.ejs';
import listService from 'ListService';


class AppAccessibilityView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = htmlTemplate;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateAttributes',
            'change input[name=focusColor]': 'updateColorAttributes',
            'change input[type=color]': 'updateColorAttributes'
        };

        if(!this.model.get("reflowEnabled")){
            this.model.set("reflowEnabled", "false", {silent:true})
        }

        this.model.set("enableReflow", listService.mobileSectionsExist(), {silent:true})


        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;

        if(propName === "reflowEnabled"){
            if(!listService.mobileSectionsExist()){
                //uncheck and show message
                alert("no mobile");
                this.model.set( propName, false );
            }
            else{
                this.model.set( propName, propVal );
            }            
        }
        else{
            this.model.set( propName, propVal );
        }
    }


    render() {
        super.render();
        
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }       

        this.delegateEvents();
        return this;
    }

}

export default AppAccessibilityView;
